if (!customElements.get('step-marquee')) {
  class StepMarquee extends HTMLElement {
    constructor() {
      super();

      this.track = null;
      this.origCount = 0;
      this.currentIndex = 0;
      this.speed = 500;
      this.rafId = null;
      this.lastTime = null;
      this.accumulated = 0;
      this.ro = null;
    }

    connectedCallback() {
      this.speed = parseInt(this.dataset.speed) || 500;
      this.track = this.querySelector('[data-track]');
      this.origCount = this.track.children.length;

      this.ro = new ResizeObserver(() => this.restart());
      this.ro.observe(this);
      this.restart();

      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      if (this.ro) this.ro.disconnect();

      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        this.lastTime = null;
        this.accumulated = 0;
      }
    };

    fill() {
      const originals = Array.from(this.track.children).slice(
        0,
        this.origCount,
      );
      const slotWidth = originals[0].offsetWidth;
      const needed =
        Math.ceil((this.offsetWidth * 2) / (slotWidth * this.origCount)) + 1;

      while (this.track.children.length > this.origCount)
        this.track.lastChild.remove();

      for (let r = 0; r < needed; r++) {
        originals.forEach((el) => this.track.appendChild(el.cloneNode(true)));
      }

      this.currentIndex = 0;
      this.track.style.transform = 'translateX(0)';
    }

    step() {
      const slotWidth = this.track.children[0].offsetWidth;
      this.currentIndex += 1;

      if (this.currentIndex * slotWidth >= slotWidth * this.origCount) {
        this.currentIndex -= this.origCount;
      }

      this.track.style.transform = `translateX(${
        -this.currentIndex * slotWidth
      }px)`;
    }

    tick(ts) {
      if (this.lastTime === null) this.lastTime = ts;
      this.accumulated += ts - this.lastTime;
      this.lastTime = ts;

      if (this.accumulated >= this.speed) {
        this.accumulated -= this.speed;
        this.step();
      }

      this.rafId = requestAnimationFrame((ts) => this.tick(ts));
    }

    restart() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.fill();
      this.lastTime = null;
      this.accumulated = 0;
      this.rafId = requestAnimationFrame((ts) => this.tick(ts));
    }
  }

  customElements.define('step-marquee', StepMarquee);
}
